import React from 'react';

// Chunky, kid-friendly 3D button.
export function KidButton({
  children,
  color = '#3B82F6',
  border = '#1D4ED8',
  text = '#ffffff',
  className = '',
  style = {},
  ...props
}) {
  return (
    <button
      className={`btn-3d px-6 py-4 text-lg sm:text-xl ${className}`}
      style={{ background: color, borderColor: border, color: text, ...style }}
      {...props}
    >
      {children}
    </button>
  );
}
